import React from "react";
import { BoxDanger, MSection, Title } from "components/misc";
import { Button, Row, Col, Icon } from "design-react-kit";
import { Helmet } from "react-helmet";
import { networkErrorHelper, pageService } from "libs";
import { FormEnabler, ValidatedForm, MInput, MSelect, MCheckbox, MSearch } from "components/forms";
import { COMPETITION_CLASS_2024, REGIONS } from "const";

export class FormAdesioni60CfuView extends ValidatedForm {

  constructor(props) {
    super(props);
    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      ccError: "",
      activeRows: [0],
      isChecked: false,
      isSuccess: 0,
      type: "percorsi_abilitanti",
    };
  }

  emptyFields = {
    name: "",
    surname: "",
    email: "",
    mobile: "",
    "competitionClass-0": "",
    "regions-0": [],
    accept: false,
  };

  ERROR_MESSAGES = {
    name: "Inserisci il tuo nome",
    surname: "Inserisci il tuo cognome",
    email: "Inserisci la tua email",
    accept: "Accetta la privacy policy per continuare",
    mobile: "Inserisci il tuo numero di telefono",
    "competitionClass-0": "Seleziona la classe di concorso",
    "competitionClass-1": "Seleziona la classe di concorso",
    "competitionClass-2": "Seleziona la classe di concorso",
    "regions-0": "Seleziona almeno una regione",
    "regions-1": "Seleziona almeno una regione",
    "regions-2": "Seleziona almeno una regione",
  };

  validation = {
    name: (value) => value && value.trim() !== "",
    surname: (value) => value && value.trim() !== "",
    accept: (value) => value === true,
    email: (value) => {
      const isEmailFilled = value && value.trim() !== "";
      const isEmailValid = isEmailFilled && /\S+@\S+\.\S+/.test(value);

      //if email is empty, check if mobile is filled
      if (!isEmailFilled) {
        return this.state.mobile.value && this.state.mobile.value.trim() !== "";
      }

      return isEmailValid;
    },
    mobile: (value) => {
      const isMobileFilled = value && value.trim() !== "";

      if (!isMobileFilled) {
        const emailValue = this.state.email.value;

        return emailValue && /\S+@\S+\.\S+/.test(emailValue);
      }

      return true;
    },
    "competitionClass-0": (value) => value !== "",
    "competitionClass-1": (value) => value !== "",
    "competitionClass-2": (value) => value !== "",
    "regions-0": (value) => Array.isArray(value) && value.length > 0 && value.length <= 3,
    "regions-1": (value) => Array.isArray(value) && value.length > 0 && value.length <= 3,
    "regions-2": (value) => Array.isArray(value) && value.length > 0 && value.length <= 3,
  };

  getFields = () => {
    const { activeRows } = this.state;

    //static fields
    const staticFields = [
      [
        { id: "name", field: "name", label: "Nome", component: MInput, type: "text", className: "col-md-6" },
        { id: "surname", field: "surname", label: "Cognome", component: MInput, type: "text", className: "col-md-6" },
      ],
      [
        { id: "email", field: "email", label: "Email", component: MInput, type: "email", className: "col-md-6" },
        { id: "mobile", field: "mobile", label: "Cellulare", component: MInput, type: "text", className: "col-md-6" },
      ],
    ];

    //dynamic cc - region fields
    const dynamicRows = [];
    activeRows.forEach((rowId, index) => {
      dynamicRows.push([
        {
          id: `competitionClass-${rowId}`,
          name: `competitionClass-${rowId}`,
          field: `competitionClass-${rowId}`,
          label: `Classe di concorso ${index + 1}`,
          payload: {
            options: [
              { value: "", label: "Seleziona classe di concorso" },
              ...Object.entries(COMPETITION_CLASS_2024).map(([value, label]) => ({
                value,
                label: `${value} - ${label}`,
              })),
            ],
          },
          component: MSelect,
          className: "col-md-6 mt-2",
        },
        {
          id: `regions-${rowId}`,
          field: `regions-${rowId}`,
          className: "col-md-5",
          component: (props) => (
            <MSearch
              {...props}
              placeHolder={`Inserisci regione (max 3)`}
              isMulti={true}
              payload={REGIONS}
              onChange={(id, selectedOptions) => this.onRegionChange(id, selectedOptions, props.onChange)}
            />
          ),
        },
        {
          id: `removeBtn-${rowId}`,
          field: `removeBtn-${rowId}`,
          className: "col-md-1 mb-5 d-flex align-items-center",
          component: () =>
            index > 0 && (
              <Button size="sm" color="" className="btn-naked" onClick={() => this.removeRow(rowId)}>
                <Icon icon="it-close-big" />
              </Button>
            ),
        },
      ]);
    });

    const bottom = [
      [
        {
          id: "addBtn",
          field: "addBtn",
          className: "col-md-12 text-right",
          component: () => (
            <Button type="button" onClick={this.addRow} color="primary bg-dark" size="sm" disabled={activeRows.length >= 3}>
              + Aggiungi classe di concorso
            </Button>
          ),
        },
        {
          id: "accept",
          field: "accept",
          label: "Dichiaro di aver letto la <a href=\"/page/privacy-policy\" className=\"link-dark\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a>  ai sensi del Regolamento UE 2016/679 (GDPR)",
          component: MCheckbox,
          className: "col-md-12 mt-2",
        },
      ],
    ];

    return [...staticFields, ...dynamicRows, ...bottom];
  };

  addRow = () => {
    const { activeRows } = this.state;

    if (activeRows.length >= 3) return;

    let newId = 0;
    while (activeRows.includes(newId)) {
      newId++;
    }

    const classKey = `competitionClass-${newId}`;
    const regionKey = `regions-${newId}`;

    this.validation[classKey] = (value) => value !== "";
    this.validation[regionKey] = (value) => Array.isArray(value) && value.length > 0 && value.length <= 3;
    this.ERROR_MESSAGES[classKey] = "Seleziona la classe di concorso";
    this.ERROR_MESSAGES[regionKey] = "Seleziona almeno una regione";

    this.setState((prev) => ({
      activeRows: [...prev.activeRows, newId],
      defaultValues: {
        ...prev.defaultValues,
        [classKey]: "",
        [regionKey]: [],
      },
    }));
  };

  removeRow = (idToRemove) => {
    if (this.state.activeRows.length <= 1) return;

    const classKey = `competitionClass-${idToRemove}`;
    const regionKey = `regions-${idToRemove}`;

    delete this.validation[classKey];
    delete this.validation[regionKey];

    this.setState((prev) => {
      const newActiveRows = prev.activeRows.filter((id) => id !== idToRemove);

      const newState = { ...prev, [classKey]: "", [regionKey]: [] };

      return {
        ...newState,
        activeRows: newActiveRows,
      };
    });
  };

  saveRemote = () => {
    const { activeRows, type } = this.state;
    const metadata = [];
    const competitionClasses = new Set();

    this.setState({ ccError: "" });

    const basePayload = {
      name: this.getValueField("name"),
      surname: this.getValueField("surname"),
      email: this.getValueField("email"),
      mobile: this.getValueField("mobile"),
      type,
    };

    for (const rowId of activeRows) {
      const classKey = `competitionClass-${rowId}`;
      const regionKey = `regions-${rowId}`;

      const cc = this.getValueField(classKey);
      const regions = this.getValueField(regionKey) || [];

      if (cc && regions.length > 0) {
        if (competitionClasses.has(cc)) {
          this.setState({ ccError: "La stessa classe di concorso è stata selezionata più di una volta." });
          return;
        }

        competitionClasses.add(cc);

        const regionValues = regions.map((r) => (typeof r === "object" && r.value ? r.value : r));
        metadata.push({
          competitionClass: cc,
          regions: regionValues,
        });
      }
    }

    const payload = {
      ...basePayload,
      metadata: metadata,
    };

    pageService
      .saveContactRequest60Cfu(payload)
      .then(() => {
        this.setState({ isSuccess: 200 });
      })
      .catch((errors) => {
        if (networkErrorHelper.is422(errors)) {
          this.setState({ isSuccess: 422 });
        }
      });
  };

  onRegionChange = (id, options, onChange) => {
    const selectedOptions = options || [];

    if (selectedOptions.length > 3) {
      return;
    }

    if (onChange) {
      onChange(id, selectedOptions);
    }
  };

  onCancel = () => {
    this.resetForm();
  };

  render() {
    const { formActive, defaultValues, ccError, isSuccess } = this.state;

    const fields = this.getFields();

    const { code } = this.renderFields(fields, defaultValues, formActive);

    const title = "Percorsi Abilitanti per Docenti 30, 36, 60 CFU o per una seconda abilitazione - A.A. 2026/2027";

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>
        <MSection>
          <Row>
            <Col>
              <div className="text-center">
                <Title>{title}</Title>
              </div>
              <p>
                Sono attualmente in fase di definizione i nuovi Percorsi Abilitanti Universitari 30, 36 e 60 CFU per l’Anno Accademico 2026/2027, destinati agli aspiranti docenti e ai docenti già in possesso dei requisiti previsti dalla normativa vigente.
              </p>
              <p>
               L'attivazione dei percorsi (oltre 50 corsi) e la pubblicazione dei relativi bandi sono subordinati all’emanazione dei provvedimenti ministeriali che autorizzeranno le Università all'erogazione e organizzazione dei corsi definendo il numero dei posti disponibili.
              </p>
              <p>
               Se vuoi proporre o sei interessato a partecipare ai percorsi abilitanti (anche in anni accademici successivi), puoi compilare il modulo di adesione per ricevere, senza alcun costo, tutte le informazioni e gli aggiornamenti non appena saranno disponibili.
              </p>
              <p>La compilazione del modulo sottostante:</p>
              <ul>
                <li>non costituisce domanda di iscrizione;</li>
                <li>non comporta alcun obbligo o impegno da parte tua;</li>
                <li>ti consentirà di ricevere in anteprima comunicazioni su bandi, modalità di accesso, scadenze e sedi di attivazione.</li>
              </ul>
              <p>
                Comunicando le classi di concorso di tuo interesse sarai inserito nel nostro servizio informativo dedicato e riceverai tempestivamente aggiornamenti riguardanti:
              </p>
              <ul>
                <li>apertura delle iscrizioni;</li>
                <li>pubblicazione dei bandi universitari;</li>
                <li>attivazione dei percorsi abilitanti;</li>
                <li>disponibilità dei posti;</li>
                <li>opportunità formative nelle regioni e nelle classi di concorso di tuo interesse.</li>
              </ul>
              <p>Compila il modulo per restare costantemente aggiornato sulle prossime opportunità relative ai Percorsi Abilitanti Docenti 2026/2027 e ricevere in anteprima le informazioni utili per orientare al meglio il tuo percorso professionale.</p>
            </Col>
          </Row>
        </MSection>
        {isSuccess === 0 ? (
          <>

            <MSection className="my-3">
              <Row>
                <Col>
                  <form className="user" id="60cfuform">
                    {code}
                  </form>

                  {ccError && <BoxDanger className="mt-3">{ccError}</BoxDanger>}

                  <div className="mt-2">
                    <FormEnabler onSubmit={this.onSubmit} onCancel={this.onCancel} onToggle={this.toggleForm} isFormActive={formActive} />
                  </div>
                </Col>
              </Row>
            </MSection>
          </>
        ) : (
          ""
        )}
        {isSuccess === 200 ? (
         <MSection className="my-3">
            <p>
              Gentile Insegnante, <br />
              la sua richiesta è stata memorizzata correttamente. <br />
            </p>{" "}
          </MSection>
        ) : (
          ""
        )}
        {isSuccess === 422 ? (
          <MSection className="my-3">
            <p>
              Gentile Insegnante, <br />è già presente una richiesta con i dati inseriti.
              <br />
            </p>{" "}
          </MSection>
        ) : (
          ""
        )}
      </>
    );
  }
}
